import { Fragment } from "react";
import StaedteError from "./Error";

export default function Endlocations(params) {
	
    const detailData = params.data;
    let errorOccured = undefined !== detailData.errors;
    
    if ( errorOccured ) {
        // TODO: How to handle missing detail data?
        return(
            <Fragment>
                <StaedteError />
            </Fragment>
        );
    } else if ( undefined === detailData || 0 === detailData.length ) {
        return;
    }

    const showStartTimes = (ev, show) => {

        let target = ev.target.closest('.staedte-endlocation-card .card');

        const overlay = target.getElementsByClassName( 'staedte-endlocation-starttimes' );

        if ( !overlay || 0 === overlay.length ) {
            return;
        }

        if ( null === show ) {
            
            show = ! overlay[0].classList.contains( 'd-none' );

        }

        if ( show ) {
            target.style.transition =  "all ease-in 0.25s";
            target.style.transform = "scale(1.025)";
            overlay[0].classList.remove( 'd-none' );
            overlay[0].classList.add( 'd-flex' );
        } else {
            overlay[0].classList.remove( 'd-flex' );
            overlay[0].classList.add( 'd-none' );
            target.style.transform = "scale(1)";
        }

    }

    const cityDetails = detailData.city_details;
    let validFacebookUrl = true;
    try {
        new URL( cityDetails.facebook );
    } catch( e ) {
        validFacebookUrl = false;
    }

    const activeTicketshop = 1 === Number( cityDetails.activeTicketshop );
    const today            = new Date( Date.now() );

    const eventDate = new Date( cityDetails.date );
    if ( cityDetails.start_time && 5 === cityDetails.start_time.length ) {
        const startTimeParts = cityDetails.start_time.split( ':' );
        const startHour      = Number( startTimeParts[0] ?? null );
        const startMins      = Number( startTimeParts[1] ?? null );
        if ( isNaN( startHour ) || isNaN( startMins ) ) {
            today.setHours( 0, 0, 0, 0 );
        } else {
            eventDate.setHours( startHour - 1, startMins );
        }
    }

    if ( "Invalid Date" === eventDate || today.getTime() > eventDate.getTime() || ! activeTicketshop ) {
        cityDetails.date_de = window.staedteFrontendShortcodeData.i18n.eventDateFollows;
    }
    
    const dayNames = window.staedteFrontendShortcodeData.i18n.weekdays;

    const local_ticket_price = isNaN( cityDetails.local_ticket_price ) ? '9.00' : cityDetails.local_ticket_price;

    var locationsSoldOut = 0;
    const eventInFuture  = new Date() <= eventDate;

    const eventDataAvailable = 'Termin folgt' !== window.staedteFrontendShortcodeData.preloaded_data.endlocation_information.city_details.date_de;

    return(
        <div className="mb-0 mb-lg-5">

            <div className="g-0 row">
                <div className="col">
                    <h5 className="mb-0 pb-0" style={{"color": "black"}}>{window.staedteFrontendShortcodeData.i18n.choseYourEndlocation}</h5>
                </div>
            </div>

            <div className="d-flex flex-wrap">

                <div id="" className="staedte-details-endlocations-container">
                    
                    {
                        detailData.end_locations.map(
                            (endlocation, index) => {
                                
                                const locationSoldOut = 1 === Number( endlocation.sold_out );
                                const localTicketingActive = 1 !== Number( endlocation.local_ticketing_active );
                                
                                locationsSoldOut += locationSoldOut ? 1 : 0;

                                let maybeValidEndlocationImgUrl = endlocation.image && 0 < endlocation.image.length;
                                if ( maybeValidEndlocationImgUrl ) {
                                    try {
                                        new URL( `https://bierbachelor.com${endlocation.image}` );
                                        maybeValidEndlocationImgUrl = true;
                                    } catch ( e ) {
                                        maybeValidEndlocationImgUrl = false;
                                    }
                                }

                                let allowPointerEvents = eventDataAvailable ? 'pe-auto' : 'pe-none';
                                let anchorCSS          = `staedte-endlocation-card text-decoration-none ${allowPointerEvents}`;

                                return(

                                    <a 
                                        href={`/tickets/${cityDetails.name}`}
                                        key={index}
                                        className={anchorCSS}
                                        onMouseOver={ev=>{showStartTimes(ev, true)}}
                                        onMouseLeave={ev=>{showStartTimes(ev, false)}}
                                        onTouch={ev=>{showStartTimes(ev, null)}}
                                    >

                                        <div className="card p-1 staedte-card border-0">
                                            
                                            <img
                                                className={ (locationSoldOut ? 'grayscale-img' : '') + ' endlocation-img border-0'}
                                                alt={endlocation.image} 
                                                src={ maybeValidEndlocationImgUrl ? `https://bierbachelor.com${endlocation.image}` : 'https://bierbachelor.com/logos/no_image.jpg'} 
                                            />
                                            
                                            <div className="staedte-endlocation-info-container">
                                                <p className="text-dark text-center card-title pb-0 mb-0"><b>{endlocation.endlocation}</b></p>
                                                <p className={ ((localTicketingActive || locationSoldOut) ? '' : 'invisible' ) + ' card-text text-center endlocation-info-text'}>
                                                    { locationSoldOut ? `(${window.staedteFrontendShortcodeData.i18n.locationSoldOut})` : `(${window.staedteFrontendShortcodeData.i18n.noBoxOffice})` }
                                                </p>
                                            </div>
                                            
                                            <div
                                                className="staedte-endlocation-starttimes d-none card-img-overlay h-auto"
                                            >
                                                <div className="d-flex m-auto p-1 flex-column staedte-endlocations-start-times">
                                                    
                                                    <p
                                                        className="pb-0 m-auto d-flex flex-row text-center mb-0"
                                                        style={{
                                                            opacity: ( endlocation.firstStartTime && 0 < endlocation.firstStartTime.length ) ? 1 : 0
                                                        }}
                                                    >
                                                        <span className="dashicons dashicons-clock"></span>
                                                        <span className="ps-2" style={{lineHeight: "1.35"}}>
                                                            {`${endlocation.firstStartTime} ${window.staedteFrontendShortcodeData.i18n.clock}*`}
                                                        </span>
                                                    </p>

                                                    <p
                                                        className="pb-0 mt-1 m-auto d-flex flex-row text-center mb-0"
                                                        style={{
                                                            opacity: ( endlocation.secondStartTime && 0 < endlocation.secondStartTime.length ) ? 1 : 0
                                                        }}
                                                    >
                                                        <span className="dashicons dashicons-welcome-learn-more"></span>
                                                        <span className="ps-2" style={{lineHeight: "1.35"}}>
                                                            {`${endlocation.secondStartTime} ${window.staedteFrontendShortcodeData.i18n.clock}*`}
                                                        </span>
                                                    </p>

                                                </div>
                                            </div>

                                        </div>
                                    </a>
                                        
                                );
                            }
                        )
                    }
                    {
                        validFacebookUrl ? 
                            <a href={cityDetails.facebook} className="staedte-endlocation-card staedte-endlocation-fb-card text-decoration-none">
                                <div className="card p-1 staedte-card border-0">
                                    
                                    <img className="endlocation-img border-0" alt={cityDetails.facebook} src="https://www.bierbachelor.com/wp-content/plugins/Staedte/lib/Kalender_Symbol.png" />
                                    
                                    <div className="staedte-endlocation-info-container">
                                        <p className="text-dark text-center card-title pb-0 mb-0">
                                            <b>
                                                {window.staedteFrontendShortcodeData.i18n.facebookEvent}
                                            </b>
                                        </p>
                                        <p className="invisible card-text text-center endlocation-info-text">
                                            &nbsp;
                                        </p>
                                    </div>
                                </div>
                            </a> : ''
                    }
                    {
                        ( window.staedteFrontendShortcodeData.i18n.eventDateFollows !== cityDetails.date_de && !(isNaN(detailData.end_locations.length) && 3 !== detailData.end_locations.length ) ) ?
                            <a href={`${window.location.protocol}//${window.location.hostname}/tickets/${cityDetails.name}`} className="staedte-endlocation-card staedte-endlocation-next-date-card text-decoration-none">
                                <div className="card p-1 ratio ratio-1x1 staedte-card border-0">
                                    
                                    <div className="d-flex flex-column">

                                        <div
                                            className="ms-auto staedte-endlocation-next-date-header me-auto mt-auto mb-3"
                                        >
                                            {window.staedteFrontendShortcodeData.i18n.nextEvent}:
                                        </div>

                                        <div
                                            className="ms-auto me-auto mb-auto staedte-endlocation-next-date-info"
                                        >
                                            {dayNames[eventDate.getDay()]}<br/>
                                            {cityDetails.date_de}
                                        </div>

                                    </div>

                                </div>
                            </a>
                        : ''
                    }
                    
                </div>
                <div className="staedte-endlocation-info-card">
                    <div className="staedte-card card">
                        
                        <div className="staedte-endlocation-infos-header-container d-flex flex-row" >
                            <h3>
                                {window.staedteFrontendShortcodeData.i18n.informations}
                            </h3>
                            <div className="ms-auto">
                                {
                                    Object.entries( detailData.social_links).map(
                                        entry => {

                                            if ( undefined !== cityDetails[ entry[0] ] && 0 < cityDetails[ entry[0] ].length ) {
                                                entry[1] = cityDetails[ entry[0] ];
                                            }

                                            if ( 'https://' !== entry[1].substring(0,8) ) {
                                                entry[1] = `https://${entry[1]}`;
                                            }

                                            return(
                                                <a
                                                    className={`ms-1 dashicons dashicons-${entry[0]}`}
                                                    key={entry[0]}
                                                    href={entry[1]}
                                                    style={{
                                                        "font-size": "30px",
                                                        "width": "30px",
                                                        "height": "30px",
                                                        "color": "#ff9858"
                                                    }}
                                                >
                                                </a>
                                            )
                                        }
                                    )
                                }
                            </div>
                        </div>
                        
                        <div className="staedte-details-info-row">

                            <div className="gray-info-box-label">
                                <b>
                                    {window.staedteFrontendShortcodeData.i18n.date}
                                </b>
                            </div>

                            <div className="staedte-details-info-data" >
                                <div className="gray-info-box">
                                    {cityDetails.date_de}
                                </div>
                            </div>
                                
                        </div>

                        <div className="staedte-details-info-row">

                            <div className="gray-info-box-label">
                                <b>
                                    {window.staedteFrontendShortcodeData.i18n.start}
                                </b>
                            </div>

                            <div className="staedte-details-info-data">

                                {
                                    detailData.start_locations.map(
                                        (startLocation, index) => {
                                            return(
                                                <div key={index} className="gray-info-box">

                                                    {startLocation.start}
                                                    &nbsp;
                                                    {
                                                        12 <= startLocation.start.length ? <br /> : ''
                                                    }
                                                    <span class="staedte-infobox-endlocation-hint" style={{fontSize: "14px"}}>
                                                        ({window.staedteFrontendShortcodeData.i18n.end}: { startLocation.endlocation })
                                                    </span>
                                                    
                                                </div>
                                            )
                                        }
                                    )
                                }
                                
                            </div>

                        </div>

                        <div className="staedte-details-info-row">

                            <div className="gray-info-box-label">
                                <b>
                                    {window.staedteFrontendShortcodeData.i18n.prepayment}
                                </b>
                            </div>

                            <div className="staedte-details-info-data">
                                {
                                    0 === detailData.vvk_locations.length ?
                                        ( 
                                            isNaN( cityDetails.price_single ) ?
                                                <div className="d-flex">
                                                    <div className="gray-info-box">
                                                        {window.staedteFrontendShortcodeData.i18n.followsSoon}
                                                    </div>
                                                </div> :
                                                <div className="gray-info-box">
                                                    ab {
                                                        new Intl.NumberFormat('de-DE',{
                                                            style: 'currency',
                                                            currency: 'EUR' 
                                                        }).format( cityDetails.price_single )
                                                    }
                                                </div>
                                        ) :
                                        detailData.vvk_locations.map(
                                            (vvk_location, index) => {
                                                return(
                                                    <div key={index} className="gray-info-box">
                                                        {vvk_location.location}
                                                    </div>
                                                )
                                            }
                                        )
                                }
                            </div>

                        </div>

                        {
                            cityDetails.local_ticketing_active ?

                                <>

                                <div className="staedte-details-info-row">

                                    <div className="gray-info-box-label">
                                        <b>
                                            {window.staedteFrontendShortcodeData.i18n.boxOffice}
                                        </b>
                                    </div>

                                    <div className="staedte-details-info-data">
                                        <div className="gray-info-box">
                                            {
                                                new Intl.NumberFormat(
                                                    'de-DE',
                                                    {
                                                        style: 'currency',
                                                        currency: 'EUR' 
                                                    }).format(local_ticket_price)
                                            }
                                        </div>
                                    </div>

                                </div>

                                <div className="staedte-details-info-row">

                                    <div className="gray-info-box-label">
                                        <b>
                                            {window.staedteFrontendShortcodeData.i18n.start}
                                        </b>
                                    </div>

                                    <div className="staedte-details-info-data">
                                        <div className="gray-info-box">
                                            {
                                                `${cityDetails?.start_time ?? '18:00'} - ${cityDetails?.max_starttime ?? '20:00'} Uhr`
                                            }
                                        </div>
                                    </div>

                                </div>
                                </>
                            : ''
                        }
                        <div className="staedte-details-button-container">
                            
                            {
                                ( eventInFuture && locationsSoldOut === detailData.end_locations.length ) ?
                                    <button className="disabled staedte-button-gray staedte-button btn" disabled>
                                        {window.staedteFrontendShortcodeData.i18n.soldOut}
                                    </button> :
                                    ( eventInFuture && activeTicketshop ) ? 
                                        <a href={`https://${window.location.hostname}/tickets/${cityDetails.name}`} className="staedte-button staedte-button-blue btn">
                                            {window.staedteFrontendShortcodeData.i18n.saveYourTickets}
                                        </a> : 
                                        <a href={`https://${window.location.hostname}/tickets`} className="staedte-button staedte-button-gray btn">
                                            {window.staedteFrontendShortcodeData.i18n.lookInYourArea}
                                        </a>           
                            }
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}